
import vSelect from 'vue-select'
import { Classifier } from '@/commons/types'
import { ValidationObserver } from 'vee-validate'
import { Component, Prop } from 'vue-property-decorator'
import { TranslationUtils } from '@/commons/utils/translations'
import { ClassifiersUtils } from '@/commons/utils/classifiers'

@Component({
    components: {
        vSelect
    }
})
export default class SelectWithSearch extends ValidationObserver {
    translateOptionText = TranslationUtils.translateClassifier
    translateNotFound = TranslationUtils.translateNotFound

    @Prop() setter!: (value: unknown) => void
    @Prop({ default: null }) validatorOnBlur!: (() => void) | null
    @Prop() classifierOptions!: Array<Classifier>
    @Prop({ default: '' }) selected!: Classifier | null
    @Prop({ default: '' }) labelTranslationKey!: string
    @Prop() excludedClassifiers: Array<string> | undefined
    @Prop({ default: false }) isEmptySelectAllowed!: boolean

    get selectValue (): Classifier | null {
        return this.selected || null
    }

    set selectValue (value: Classifier | null) {
        this.setter(value ? value.code : null)
    }

    get isEmptySelectHidden (): boolean {
        return !!(!this.isEmptySelectAllowed && this.selectValue)
    }

    get filteredClassifierOptions (): Array<Classifier> {
        const filteredClassifiers = this.classifierOptions.filter((classifier: Classifier) => {
            if (!this.excludedClassifiers || this.excludedClassifiers.length < 1) {
                classifier.label = this.translateOptionText(classifier)
                return true
            }
            return this.excludedClassifiers.indexOf(classifier.code) < 0
        })
        return ClassifiersUtils.sortAlphabetically(filteredClassifiers)
    }

    handleBlur () {
        if (this.validatorOnBlur) {
            this.validatorOnBlur()
        }
    }
}
